import { render, staticRenderFns } from "./MineEmpty.vue?vue&type=template&id=162de84a&scoped=true&"
import script from "./MineEmpty.vue?vue&type=script&lang=js&"
export * from "./MineEmpty.vue?vue&type=script&lang=js&"
import style0 from "./MineEmpty.vue?vue&type=style&index=0&id=162de84a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162de84a",
  null
  
)

export default component.exports